import type { TZDate } from "@date-fns/tz";
import type { ChipProps } from "@mui/material";
import type { ReactNode } from "react";

export enum Day {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNSEDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

export interface ICalendarCell<T = undefined> {
  date: TZDate;
  eventsPositionOffset: number;
  events: TCalendarEventRange<T>[];
  disabled: boolean;
}

export type TCalendarEvent<T = undefined> = {
  id: string;
  variant?: ChipProps["variant"];
  color?: ChipProps["color"];
  sx?: ChipProps["sx"];
  icon?: ReactNode;
  label: string;
  startDate: Date;
  endDate?: Date;
  children: TCalendarEvent<T>[];
} & (T extends undefined ? { data?: T } : { data: T });

export type TCalendarEventRange<T = undefined> = TCalendarEvent<T> & { startRange: TZDate; endRange: TZDate };
